import styled from '@emotion/styled';
import {Block} from '@travel-frontend/ui-components';

export const Container = styled(Block)`
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  color: ${({theme}) => theme.colors.contentSecondary};
`;
